// return true if element equals value
const standardFilter = (el, val, filterCol) => {
    return el[filterCol] == val;
}

export default standardFilter;